import { post, get, patch, postFormData } from "services";
import routes from "./routes";

const SystemServices = {
  reCaptchaVerify: async (obj) => {
    const data = await post(routes.reCaptchaVerify, obj);
    return data;
  },
  uploadDocuments: async (obj) => {
    const data = await post(routes.uploadDocuments, obj);
    return data;
  },

  generateSessionID: async () => {
    const data = await post(routes.generateSessionID, {
      withCredentials: true,
    });
    return data;
  },
  getBankDetails: async () => {
    const data = await get(routes.getBankDetails);
    return data;
  },
  getSubCustomerPermissions: async (params) => {
    const data = await get(routes.getSubCustomerPermissions, params);
    return data;
  },
  getPickupLocations: async (params) => {
    const data = await get(routes.getPickupLocations, params);
    return data;
  },
  getWebTokens: async () => {
    const data = await post(routes.getWebTokens);
    return data;
  },
  createPickupLocation: async (obj) => {
    const data = await post(routes.createPickupLocation, obj);
    return data;
  },
  createFinalDestination: async (obj) => {
    const data = await post(routes.createFinalDestination, obj);
    return data;
  },
  deleteFinalDestination: async (obj) => {
    const data = await patch(routes.deleteFinalDestination, obj);
    return data;
  },
  ApplyPermissions: async (obj) => {
    const data = await patch(routes.ApplyPermissions, obj);
    return data;
  },
  getBranches: async () => {
    const data = await get(routes.getBranches);
    return data;
  },
  getVoucherBranches: async (params) => {
    const data = await get(routes.getVoucherBranches, params);
    return data;
  },
  getNotifications: async () => {
    const data = await get(routes.getNotifications);
    return data;
  },
  getNotificationsCount: async () => {
    const data = await get(routes.getNotificationsCount);
    return data;
  },
  getBusinessRegions: async (params) => {
    const data = await get(routes.getBusinessRegions, params);
    return data;
  },
  getFinalDestinations: async (params) => {
    const data = await get(routes.getFinalDestinations, params);
    return data;
  },
  handleExternalData: async (params) => {
    const data = await get(routes.handleExternalData, params);
    return data;
  },
  getCurrencies: async (params) => {
    const data = await get(routes.getCurrencies, params);
    return data;
  },
  getWarehouses: async (params) => {
    const data = await get(routes.getWarehouses, params);
    return data;
  },
  getCountries: async () => {
    let params = { page: 1, limit: 1000 };
    const data = await get(routes.getCountries, params);
    return data;
  },
  getCountriesExport: async () => {
    let params = { page: 1, limit: 1000 };
    const data = await get(routes.getCountriesExport, params);
    return data;
  },
  getStates: async (countryId) => {
    let params = { page: 1, limit: 1000, country_id: countryId };
    const data = await get(routes.getStates, params);
    return data;
  },
  getCities: async (stateId) => {
    let params = { page: 1, limit: 1000, state_id: stateId };
    const data = await get(routes.getCities, params);
    return data;
  },
  getMakes: async (params) => {
    const data = await get(routes.getMakes, params);
    return data;
  },
  createMake: async (obj) => {
    const data = await post(routes.createMake, obj);
    return data;
  },
  getModels: async (params) => {
    const data = await get(routes.getModels, params);
    return data;
  },
  createModel: async (obj) => {
    const data = await post(routes.createModel, obj);
    return data;
  },
  createBranch: async (obj) => {
    const data = await post(routes.createBranch, obj);
    return data;
  },
  getColors: async (params) => {
    const data = await get(routes.getColors, params);
    return data;
  },
  createColor: async (obj) => {
    const data = await post(routes.createColor, obj);
    return data;
  },
  getShippingLines: async (params) => {
    const data = await get(routes.getShippingLines, params);
    return data;
  },
  createShippingLine: async (obj) => {
    const data = await post(routes.createShippingLine, obj);
    return data;
  },
  getShippingVendors: async (params) => {
    const data = await get(routes.getShippingVendors, params);
    return data;
  },
  createShippingVendor: async (obj) => {
    const data = await post(routes.createShippingVendor, obj);
    return data;
  },
  getGalaxyYards: async (params) => {
    const data = await get(routes.getGalaxyYards, params);
    return data;
  },
  createGalaxyYard: async (obj) => {
    const data = await post(routes.createGalaxyYard, obj);
    return data;
  },
  getClearers: async (params) => {
    const data = await get(routes.getClearers, params);
    return data;
  },
  createClearer: async (obj) => {
    const data = await post(routes.createClearer, obj);
    return data;
  },
  getVehicleTowers: async (params) => {
    const data = await get(routes.getVehicleTowers, params);
    return data;
  },
  createVehicleTower: async (obj) => {
    const data = await post(routes.createVehicleTower, obj);
    return data;
  },
  getContainerSizes: async (params) => {
    const data = await get(routes.getContainerSizes, params);
    return data;
  },
  createContainerSize: async (obj) => {
    const data = await post(routes.createContainerSize, obj);
    return data;
  },
  getServiceProviders: async (params) => {
    const data = await get(routes.getServiceProviders, params);
    return data;
  },
  createServiceProvider: async (obj) => {
    const data = await post(routes.createServiceProvider, obj);
    return data;
  },
  getDestinations: async (params) => {
    const data = await get(routes.getDestinations, params);
    return data;
  },
  createDestination: async (obj) => {
    const data = await post(routes.createDestination, obj);
    return data;
  },
  getBusinessCountries: async (params) => {
    const data = await get(routes.getBusinessCountries, params);
    return data;
  },
  getBusinessLocation: async (countryId) => {
    let params = { page: 1, limit: 1000, country_id: countryId };
    const data = await get(routes.getBusinessLocation, params);
    return data;
  },
  getBusinessLocationList: async (params) => {
    const data = await get(routes.getBusinessLocation, params);
    return data;
  },
  getLoadingPorts: async () => {
    const data = await get(routes.getLoadingPorts);
    return data;
  },
  getEmployeeDepartments: async () => {
    const data = await get(routes.getEmployeeDepartments);
    return data;
  },
  createEmployeeDepartment: async (obj) => {
    const data = await post(routes.createEmployeeDepartment, obj);
    return data;
  },
  notificationSeen: async (obj) => {
    const data = await patch(routes.notificationSeen, obj);
    return data;
  },
  forwardToPDFWhatsApp: async (obj) => {
    const data = await post(routes.sendPdfToWhatsApp, obj);
    return data;
  },
  forwardToPDFEmail: async (obj) => {
    const data = await post(routes.sendPdfToEmail, obj);
    return data;
  },
  getAllScheduleReports: async (obj) => {
    const data = await get(routes.getAllScheduleReports);
    return data;
  },

  uploadERPInvoices: async (obj) => {
    const data = await postFormData(routes.uploadERPInvoices, obj, true);
    return data;
  },
  getCylinders: async (params) => {
    const data = await get(routes.getCylinders, params);
    return data;
  },
  createCylinders: async (obj) => {
    const data = await post(routes.createCylinders, obj);
    return data;
  },
  getDriveTrains: async (params) => {
    const data = await get(routes.getDriveTrains, params);
    return data;
  },
  createDriveTrains: async (obj) => {
    const data = await post(routes.createDriveTrains, obj);
    return data;
  },
  getEnginTypes: async (params) => {
    const data = await get(routes.getEnginTypes, params);
    return data;
  },
  createEnginTypes: async (obj) => {
    const data = await post(routes.createEnginTypes, obj);
    return data;
  },

  getFuelTypes: async (params) => {
    const data = await get(routes.getFuelTypes, params);
    return data;
  },
  createFuelTypes: async (obj) => {
    const data = await post(routes.createFuelTypes, obj);
    return data;
  },
  getHighlights: async (params) => {
    const data = await get(routes.getHighlights, params);
    return data;
  },
  createHighlights: async (obj) => {
    const data = await post(routes.createHighlights, obj);
    return data;
  },
  getOdometer: async (params) => {
    const data = await get(routes.getOdometer, params);
    return data;
  },
  createOdometer: async (obj) => {
    const data = await post(routes.createOdometer, obj);
    return data;
  },
  getTransmission: async (params) => {
    const data = await get(routes.getTransmission, params);
    return data;
  },
  createTransmission: async (obj) => {
    const data = await post(routes.createTransmission, obj);
    return data;
  },
  getPrimaryDamages: async (params) => {
    const data = await get(routes.getPrimaryDamages, params);
    return data;
  },
  createPrimaryDamages: async (obj) => {
    const data = await post(routes.createPrimaryDamages, obj);
    return data;
  },

  // Trigger the SOA cron pipeline for a single customer. Renders the PDF via
  // the same /print/* page the real cron uses, uploads to S3, and (when
  // send_whatsapp is true) fires the Twilio template to test_phone.
  // body: { customer_id, soa_type: "shipping" | "vehicle", test_phone, send_whatsapp }
  runSoaTest: async (obj) => {
    const data = await post(routes.runSoaTest, obj);
    return data;
  },
};

export default SystemServices;
